import script from "./photoAlbum.vue?vue&type=script&lang=ts&setup=true"
export * from "./photoAlbum.vue?vue&type=script&lang=ts&setup=true"

import "./photoAlbum.vue?vue&type=style&index=0&id=efec69ba&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efec69ba"]])

export default __exports__